<template>
  <div>
    <Header />
    <v-progress-linear
          indeterminate
          height="6"
          color="blue darken-2"
          v-if="ploading"
          absolute
        ></v-progress-linear>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-row class="statusTabLine">
            <v-col
              cols="12"
              sm="12"
              class="d-flex align-center"
            >
              <div v-for="item in tabs" v-bind:key="item.id">
                <v-btn flat v-bind:class="['statusTab', {activeStatusTab: item.slug==activeTab.slug }]" @click="changeTab(item)" :data-attr="item.slug" :disabled="item.disabled">
                  <span v-if="item.slug != order.status.slug">
                    {{item.name}}
                  </span>
                  <span v-else>{{item.name}}<br />(Current Status)</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 v-if="activeTab.slug=='in-house' || activeTab.slug=='in-house' || activeTab.slug=='in-house'">
          <InHouse :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='run-seet-ui'">
          <RunSheetUI :order="order" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='data-entry'">
          <DataEntry :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='q-a'">
          <QA :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='qa-feedback'">
          <QAFeedback :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='approved-to-sent'">
          <ApprovedToSend :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='sent'">
          <SentToClient :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else-if="activeTab.slug=='assign'">
          <Assign :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
        <v-flex xs12 v-else>
          <InHouse :order="order" :order_eta="order_eta" :documentPath="documentPath" @updateOrder="updateOrder" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import JwtService from '@/common/jwt.service'
import Header from '@/components/header.vue'
import InHouse from '@/components/inHouse.vue'
import RunSheetUI from '@/components/runSheetUi.vue'
import Assign from '@/components/assign.vue'
import DataEntry from '@/components/dataEntry.vue'
import QA from '@/components/qa.vue'
import QAFeedback from '@/components/qaFeedback.vue'
import ApprovedToSend from '@/components/approvedToSend.vue'
import SentToClient from '@/components/sentToClient.vue'
import { GETORDERBYYID, GETORDERETASBYYORDERID } from '@/store/actions.type'
import Vue from 'vue'

Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'home',
  components: {
    Header,
    InHouse,
    Assign,
    DataEntry,
    QA,
    QAFeedback,
    ApprovedToSend,
    SentToClient,
    RunSheetUI
  },
  data () {
    return {
      // documentPath: 'http://127.0.0.1:8000/media/packages/c3ldJ-1728303-ALLINDEX.pdf',
      documentPath: null,
      files: [],
      selected: [],
      ploading: false,
      loading: true,
      order: null,
      order_eta: { order: null, eta_status: null, eta_notes: null, shared_with_client: false, created_on: null, created_by: { username: null } },
      orderStatus: null,
      firstPanTabs: null,
      firstPanTabsText: 'loreum',
      tabs: [
        {
          'id': 1,
          'name': 'Assign',
          'slug': 'assign',
          'disabled': false
        },
        {
          'id': 3,
          'name': 'In House',
          'slug': 'in-house',
          'disabled': false
        },
        {
          'id': 4,
          'name': 'Data Entry',
          'slug': 'data-entry',
          'disabled': false
        },
        {
          'id': 5,
          'name': 'QA',
          'slug': 'q-a',
          'disabled': false
        },
        {
          'id': 6,
          'name': 'QA Feedback',
          'slug': 'qa-feedback',
          'disabled': false
        },
        {
          'id': 7,
          'name': 'Approved to sent',
          'slug': 'approved-to-sent',
          'disabled': false
        },
        {
          'id': 8,
          'name': 'Sent to Client',
          'slug': 'sent',
          'disabled': false
        }
      ],
      activeTab: null
    }
  },
  mounted () {
    console.log(this.$route.params)
    this.tabs = JwtService.getOrderMenu()
    console.log('tabs................', this.tabs)
    let payload = {
      id: this.$route.params.uid
    }
    this.$store
      .dispatch(GETORDERBYYID, payload)
      .then(response => {
        this.order = response
        this.activeTab = this.order.status
        this.loading = false
        console.log(this.order)
      })
    let etaPayload = {
      order__id: this.$route.params.uid,
      page: 1,
      itemsPerPage: 1
    }
    this.$store
      .dispatch(GETORDERETASBYYORDERID, etaPayload)
      .then(response => {
        if (response.count > 0) {
          this.order_eta = response.results[0]
        }
        this.loading = false
      })
  },
  methods: {
    openOrderPage (order) {
      console.log(order)
    },
    changeTab (tab) {
      this.ploading = true
      if (tab.id <= this.order.status.id) {
        this.activeTab = tab
        setTimeout(() => {
          this.ploading = false
        }, 1000)
      } else {
        alert('Order has not yet reached this stage')
        this.ploading = false
      }
    },
    updateOrder (order) {
      console.log(this.order)
      this.order = order
    }
  },
  watch: {
    order: {
      immediate: true,
      handler (newVal, oldVal) {
        console.log(newVal, oldVal)
        this.activeTab = this.order.status
      }
    }
  }
}
</script>

<style>
body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 96%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: grey!important;
    display: table;
    color: white !important;
}
</style>
